import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Routes that count as "where the user was browsing results". The smart
// back-link on details pages returns here.
const isMapRoute = (pathname) =>
  pathname === "/" ||
  /^\/events\/[^/]+?\/?$/.test(pathname) ||
  /^\/cities\//.test(pathname) ||
  /^\/lists\/[^/]+?\/?$/.test(pathname);

// Singletons shared across all hook consumers
let lastMapUrl = "/";
let hasMapHistory = false;

const useLastMapUrl = () => {
  const location = useLocation();

  useEffect(() => {
    if (isMapRoute(location.pathname)) {
      lastMapUrl = location.pathname + location.search;
      hasMapHistory = true;
    }
  }, [location.pathname, location.search]);

  return lastMapUrl;
};

export const useHasMapHistory = () => {
  // Re-render on route changes so consumers pick up flips from false → true
  useLocation();
  return hasMapHistory;
};

// Test-only: reset module-level singletons between tests
export const __resetForTests = () => {
  lastMapUrl = "/";
  hasMapHistory = false;
};

export { isMapRoute };
export default useLastMapUrl;
